export const genEmptyOssltModules = (sections_allowed: number[]) => {
    let id = 1
    return sections_allowed.map( sectionId => {
        return {
            id: id++,
            sectionId,
            complete: false,
            hasFlags: false,
            hasUnfilled: false,
            arrayOfUnfilledQuestions: [],
            arrayOfFlaggedQuestions: []
        }
    })
}

export const OSSLT_MODULE_DEFS = {
        'Real-Life Narrative' : {
            'en': {
                title_slug: 'lbl_reading',
            }, 
            'fr': {
                title_slug: 'lbl_reading',
            }
        },
        'Récit de vie' : {
            'en': {
                title_slug: 'lbl_reading',
            }, 
            'fr': {
                title_slug: 'lbl_reading',
            }
        },
        'Information Paragraph' : {
            'en': {
                title_slug: 'lbl_reading',
            },
            'fr': {
                title_slug: 'lbl_reading',
            }
        },
        'Paragraphe informatif' : {
            'en': {
                title_slug: 'lbl_reading',
            },
            'fr': {
                title_slug: 'lbl_reading',
            }
        },
        'News Report' : {
            'en': {                    
                title_slug: 'lbl_reading',
            },
            'fr': {
                title_slug: 'lbl_reading',
            }
        },
        'Nouvelle journalistique' : {
            'en': {                    
                title_slug: 'lbl_reading',
            },
            'fr': {
                title_slug: 'lbl_reading',
            }
        },
        'Dialogue' : {
            'en': {
                title_slug: 'lbl_reading',
            },
            'fr': {
                title_slug: 'lbl_reading',
            }
        },
        'Writing Multiple Choice' : {
            'en': {
                title_slug: 'lbl_writing',
            },
            'fr': {
                title_slug: 'lbl_writing',
            }
        },
        'Questions à choix multiple en écriture' : {
            'en': {
                title_slug: 'lbl_writing',
            },
            'fr': {
                title_slug: 'lbl_writing',
            }
        },
        'Writing Convention Questions' : {
            'en': {
                title_slug: 'lbl_writing',
            },
            'fr': {
                title_slug: 'lbl_writing',
            }
        },
        'Writing Conventions Questions' : {
            'en': {
                title_slug: 'lbl_writing',
            },
            'fr': {
                title_slug: 'lbl_writing',
            }
        },
        'Questions sur les conventions linguistiques' : {
            'en': {
                title_slug: 'lbl_writing',
            },
            'fr': {
                title_slug: 'lbl_writing',
            }
        },
        'Series of Paragraphs' : {
            'en': {
                title_slug: 'lbl_writing',
            },
            'fr': {
                title_slug: 'lbl_writing',
            }
        },
        'Texte d’opinion' : {
            'en': {
                title_slug: 'lbl_writing',
            },
            'fr': {
                title_slug: 'lbl_writing',
            }
        },
        'Opinion Essay' : {
            'en': {
                title_slug: 'lbl_writing',
            },
            'fr': {
                title_slug: 'lbl_writing',
            }
        },
        'Reading' : {
            'en': {
                title_slug: 'lbl_reading',
            }, 
            'fr': {
                title_slug: 'lbl_reading',
            }
        },
        'Lecture' : {
            'en': {
                title_slug: 'lbl_reading',
            }, 
            'fr': {
                title_slug: 'lbl_reading',
            }
        },
        'Writing' : {
            'en': {
                title_slug: 'lbl_writing',
            }, 
            'fr': {
                title_slug: 'lbl_writing',
            }
        },
        'Écriture' : {
            'en': {
                title_slug: 'lbl_writing',
            }, 
            'fr': {
                title_slug: 'lbl_writing',
            }
        },
        'FT Passage' : {
            'en': {
                title_slug: 'lbl_reading',
            }, 
            'fr': {
                title_slug: 'lbl_reading',
            }
        },
        'Long Writing' : {
            'en': {
                title_slug: 'lbl_writing',
            }, 
            'fr': {
                title_slug: 'lbl_writing',
            }
        },
    }